import { Box, Theme, t as themeResolver } from '@bechtel/gds';
import styled, { css } from 'styled-components';

interface StatusStyledProps {
  fillColor?: string;
}

interface ReqItemCardStyledProps {
  selected?: boolean;
}

export const StatusBarStyled = styled(Box)<StatusStyledProps>`
  ${({ theme, fillColor }) => css`
    height: 100%;
    width: 5px;
    background-color: ${themeResolver(`colors.${fillColor}`)};
    border-radius: ${theme.radii[200]};
    position: absolute;
    left: 4px;
  `}
`;

export const ReqItemCardStyled = styled(Box).attrs({
  px: { sm: '300' },
  flexDirection: { sm: 'column' },
  py: { sm: '400' },
})<ReqItemCardStyledProps & Partial<Theme>>`
  ${({ theme, selected }) => css`
    background-color: ${selected ? theme.colors.blue[100] : theme.colors.white};
    border-bottom: 1px solid ${theme.colors.grey[200]};
    box-shadow: 2px 0 2px 0 rgba(0, 0, 0, 0.16);
    cursor: pointer;
  `}
`;

export const ReqHistoryListWrapper = styled(Box).attrs({
  flexShrink: { sm: 0 },
  justifyContent: { sm: 'flex-start' },
  flexDirection: { sm: 'column' },
  pt: { sm: '200' },
})`
  ${({ theme }) => css`
    width: 350px;
    overflowy: auto;
    height: 100%;
    border-right: 1px solid ${theme.colors.grey[200]};
    overflow-y: auto;
  `}
`;
